<template>
    <page-layout>
        <template #header>
            <page-title title="Tasks summary" @on-close="handleClose" />
        </template>
        <template #default>
            <g-button icon="angle-left" class="margin-bottom-large" size="small" @click="handleClose">Back</g-button>

            <g-typography tag="p" class="margin-bottom-large">
                Select the task you want to deliver content for.
            </g-typography>

            <activation-card v-for="brief in briefs" :key="brief.id" :brief="brief" />
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../layouts/PageLayout.vue';
    import PageTitle from '../../library/PageTitle.vue';
    import ActivationCard from './partials/ActivationCard.vue';

    export default {
        name: 'ActivationTasksSummaryView',
        components: {
            PageLayout,
            PageTitle,
            ActivationCard
        },
        props: {
            briefs: {
                type: Array,
                default: () => []
            }
        },

        setup(_, { emit }) {
            const handleClose = () => {
                emit('close');
            };

            return {
                handleClose
            };
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-large {
        margin-bottom: $g-spacing-6;
    }
</style>
